import { formatBigNumbers } from 'src/App/Utils/Numberformatter';
import { ILeaderCommand } from 'src/App/Types/leader.types';
import { LeaderboardItemContain, LIBitsContainer, LIListHeader, LIList, LIListItem, LIElipsedName, LIRankContainer } from './LeaderboardItem.styles';
import Images from 'src/App/Images';
import { useCallback } from 'react';

export function LeaderboardCommandItem({ commands }: { commands: ILeaderCommand[] }) {
	const renderRankImgs = useCallback((idx) => {
		if (idx == 1) {
			return <Images.FirstPlace />;
		} else if (idx == 2) {
			return <Images.SecondPlace />;
		} else if (idx == 3) {
			return <Images.ThirdPlace />;
		} else {
			return idx;
		}
	}, []);

	return (
		<LeaderboardItemContain>
			<LIListHeader>
				<div>Rank</div>
				<div>Command</div>
				<div />
			</LIListHeader>
			<LIList>
				{commands.map((command, idx) => (
					<LIListItem key={command.name + command.submissions}>
						<LIRankContainer>{renderRankImgs(idx + 1)}</LIRankContainer>
						<LIElipsedName>{command.name}</LIElipsedName>
						<LIBitsContainer>x{formatBigNumbers(command.submissions ?? 0)}</LIBitsContainer>
					</LIListItem>
				))}
			</LIList>
		</LeaderboardItemContain>
	);
}
